import { useLocation } from 'react-router-dom';
import { GUIDE_ARTICLES } from '../../guide/guideContent';

export function pageArticle(pathname) {
  const matches = item => {
    if (!item.path) return false;
    const pattern = item.path.split('/'), actual = pathname.split('/');
    return actual.length >= pattern.length && pattern.every((part, index) => part.startsWith(':') || part === actual[index]) &&
      (pattern.length > 2 || pattern.length === actual.length);
  };
  return GUIDE_ARTICLES.filter(matches).sort((a, b) => b.path.split('/').length - a.path.split('/').length)[0];
}

export default function PortalPageTitle({ portal = 'erp' }) {
  const { pathname } = useLocation();
  const article = pageArticle(pathname);
  return <div className="erp-page-context">
    <p className="text-xs text-gray-400">Jaggi Sweets · {portal === 'vendor' ? 'Vendor portal' : 'ERP'}</p>
    <h1>{article?.title || (portal === 'vendor' ? 'Vendor dashboard' : 'Dashboard')}</h1>
  </div>;
}
